export default __webpack_public_path__ + "static/media/icone-download.dc3f1ae8.svg";